export default __webpack_public_path__ + "static/media/A.ff37c949.png";